var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 13.3594C2.31923 13.3594 2.10938 13.1495 2.10938 12.8906V1.93359C2.10938 0.867393 2.97677 0 4.04297 0H12.4219C12.6808 0 12.8906 0.209883 12.8906 0.46875V11.25C12.8906 11.5089 12.6808 11.7188 12.4219 11.7188C12.163 11.7188 11.9531 11.5089 11.9531 11.25V0.9375H4.04297C3.49371 0.9375 3.04688 1.38434 3.04688 1.93359V12.8906C3.04688 13.1495 2.83702 13.3594 2.57812 13.3594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 15H4.21875C3.05563 15 2.10938 14.0537 2.10938 12.8906C2.10938 11.7275 3.05563 10.7812 4.21875 10.7812H12.4219C12.6808 10.7812 12.8906 10.9911 12.8906 11.25C12.8906 11.5089 12.6808 11.7188 12.4219 11.7188H4.21875C3.57258 11.7188 3.04688 12.2445 3.04688 12.8906C3.04688 13.5368 3.57258 14.0625 4.21875 14.0625H12.4219C12.6808 14.0625 12.8906 14.2724 12.8906 14.5312C12.8906 14.7901 12.6808 15 12.4219 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 13.3594H4.21875C3.95985 13.3594 3.75 13.1495 3.75 12.8906C3.75 12.6318 3.95985 12.4219 4.21875 12.4219H12.4219C12.6808 12.4219 12.8906 12.6318 12.8906 12.8906C12.8906 13.1495 12.6808 13.3594 12.4219 13.3594Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 11.7188C4.4286 11.7188 4.21875 11.5089 4.21875 11.25V0.46875C4.21875 0.209883 4.4286 0 4.6875 0C4.9464 0 5.15625 0.209883 5.15625 0.46875V11.25C5.15625 11.5089 4.9464 11.7188 4.6875 11.7188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.a28fb63a97f552c26b2c0d2b13e12537.svg";
export { ForwardRef as ReactComponent };